<template>
  <!--
    WHAT: Full-page wrapper for the "Contract Scoring" sub-tab of the Quality
          Metrics artifact — the single place to edit a contract performance
          year's tracker spec: its contract-level parameters (the scoring_config
          EAV) and every measure's relationship to it (weight / goal / tiers).
    WHERE: Rendered by MetricStudio.vue as a `managerTabs` entry on the quality
           artifact, beside Measures and Contract Assignments.
    CONTRACT: No props, no emitted events. All state lives in
              QualityContractScoring.
    NOTE: Contract Assignments (QualityManager) answers "which measures belong to
          which contract"; this answers "how does that contract score". They are
          deliberately separate surfaces over the same EntityMetric rows.
  -->
  <div class="h-full overflow-y-auto ms2-scroll">
    <QualityContractScoring />
  </div>
</template>

<script>
import QualityContractScoring from '@/components/Metric/Metric_Builder/QualityContractScoring.vue';

export default {
  name: 'QualityScoringManager',
  components: { QualityContractScoring },
};
</script>

<style scoped>
.ms2-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
.ms2-scroll::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 10px; border: 3px solid transparent; background-clip: content-box; }
</style>
